import { classnames } from '@/helpers';
import { ElementType, ReactNode } from 'react';

type ContainerLayoutProps = {
  as?: ElementType;
  className?: string;
  innerClassName?: string;
  children: ReactNode;
};

/**
 * outer is a size container (@container) with max width = theme('screens.2xl')
 * inner handles padding that adapts via viewport AND container queries
 */
export default function ContainerLayout({
  as: Component = 'div',
  className,
  innerClassName,
  children,
}: ContainerLayoutProps) {
  return (
    <Component className={classnames('@container mx-auto max-w-screen-2xl', className)}>
      <div className={classnames('container-layout__inner', innerClassName)}>{children}</div>
    </Component>
  );
}
